<script setup lang="ts">
import type { DialogTitleProps as DialogRootTitleProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';
import { DialogTitle, useForwardProps } from 'reka-ui';
import { computed } from 'vue';

export type DialogTitleProps = DialogRootTitleProps & {
	class?: HTMLAttributes['class'];
};

const props = defineProps<DialogTitleProps>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<DialogTitle
		v-bind="forwardedProps"
		:class="
			cn('text-lg font-semibold leading-none tracking-tight', props.class)
		"
	>
		<slot></slot>
	</DialogTitle>
</template>
